import firebase from 'firebase'
import 'firebase/analytics'
require('firebase/auth')
require('firebase/firestore')
require('firebase/storage')
require('firebase/messaging')

const config = {
    apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
    authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
    projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.VUE_APP_FIREBASE_APP_ID,
    measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
}

const STALE_CACHE_KEY = 'firestore_cache_reset_attempted'

function deleteIndexedDb(name) {
    return new Promise(resolve => {
        const req = indexedDB.deleteDatabase(name)
        req.onsuccess = resolve
        req.onerror = resolve
        req.onblocked = resolve
    })
}

// ponytail: clearPersistence() fails after Firestore is live; raw IDB delete + reload works once
async function deleteFirestoreIndexedDB(projectId) {
    const names = new Set([`firestore/(default)/${projectId}/main`])
    if (indexedDB.databases) {
        const dbs = await indexedDB.databases()
        dbs.forEach(db => {
            if (db.name?.startsWith('firestore/') && db.name.includes(projectId)) {
                names.add(db.name)
            }
        })
    }
    await Promise.all([...names].map(deleteIndexedDb))
}

firebase.initializeApp(config)

const db = firebase.firestore()

async function enableFirestorePersistence() {
    try {
        await db.enablePersistence()
        localStorage.removeItem(STALE_CACHE_KEY)
        return true
    } catch (err) {
        if (err.code === 'failed-precondition') {
            if (/newer version|not compatible/i.test(err.message)) {
                if (!localStorage.getItem(STALE_CACHE_KEY)) {
                    localStorage.setItem(STALE_CACHE_KEY, '1')
                    await deleteFirestoreIndexedDB(config.projectId)
                    window.location.reload()
                    return new Promise(() => {})
                }
                console.warn(
                    'Firestore offline cache is still incompatible. Clear site data once: DevTools → Application → Clear site data.'
                )
            } else {
                console.log(
                    'Multiple tabs open, persistence can only be enabled in one tab at a time.'
                )
            }
        } else if (err.code === 'unimplemented') {
            console.log(
                'The current browser does not support all of the features required to enable persistence'
            )
        }
        return false
    }
}

/** Resolves true when offline cache is active, false otherwise. Await before cache reads. */
export const firestorePersistenceReady = enableFirestorePersistence()
export const auth = firebase.auth
export const firestore = db
export const storage = firebase.storage
export const timestamp = firebase.firestore.Timestamp
export const analytics = firebase.analytics()
// notifications
export const messaging = firebase.messaging.isSupported()
    ? firebase.messaging()
    : undefined

export const vapidKey = process.env.VUE_APP_VAPIDKEY
//
export default firebase
